import type { FormDataOf } from '../../../../../types/templates';
import { disneyEspnPlayerVSPlayer } from '..';

type FormData = FormDataOf<typeof disneyEspnPlayerVSPlayer>;

export const applyFieldLogic = (fieldKey: string, _value: unknown, _formData: FormData): Partial<FormData> => {
  const updates: Partial<FormData> = {};

  if (fieldKey === 'league') {
    updates.team1 = '';
    updates.player1 = '';
    updates.team2 = '';
    updates.player2 = '';
  }
  if (fieldKey === 'team1') updates.player1 = '';
  if (fieldKey === 'team2') updates.player2 = '';

  return updates;
};
